
import { gql } from "graphql-tag";

const UID = "feature-tags";
const PAGE_TYPE = "feature_tags";
const FEATURE_TAGS_QUERY = gql`
  query feature_tags($uid: String!, $lang: String = "en-in") {
    feature_tags(uid: $uid, lang: $lang) {
      tags_group {
        tag_id
        tag_image
        display_name
        description
      }
    }
  }
`;

export default {
  props: { tags: { type: Array, default: () => [] } },

  data: () => ({ selectedFeatureTagId: "", featureTags: [] }),

  async fetch() {
    const { [PAGE_TYPE]: data } = await this.$prismicGql.request({
      query: FEATURE_TAGS_QUERY,
      variables: { uid: UID },
    });

    this.featureTags = (data?.tags_group ?? []).filter(item =>
      // eslint-disable-next-line unicorn/prefer-includes
      this.tags.some(tag => item?.tag_id === tag)
    );
  },

  fetchOnServer: false,

  methods: {
    selectFeatureTile(tagId) {
      this.selectedFeatureTagId = tagId;
    },
  },
};
